<template>
  <section class="section">
    <Loader :isLoading="this.isLoading"></Loader>

    <div v-if="!isLoading" class="section">
      <div class="columns is-multiline">
        <div class="column is-3-desktop is-4-tablet is-8-mobile flex-column"
             v-for="bestPracticeTopic in bestPracticeTopics"
             :key="bestPracticeTopic.sys.id">
          <div class="topic-card" :style="'border: 4px solid' + bestPracticeTopic.fields.boxColorInHex">
            <BestPracticeTopicCard :bestPracticeTopic="bestPracticeTopic"></BestPracticeTopicCard>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  /* Services */
  import Contentful from '@/services/Contentful'

  /* Components */
  import BestPracticeTopicCard from '@/components/BestPractice/TopicCard'
  import Loader from '@/components/General/Loader'

  export default {
    data () {
      return {
        bestPracticeTopics: [],
        isLoading: true
      }
    },
    async mounted () {
      this.bestPracticeTopics = (await Contentful.getAllBestPracticeTopics()).data.items
      this.isLoading = false
      /* Scroll to top */
      window.scrollTo(0, 0)
    },
    components: {
      BestPracticeTopicCard,
      Loader
    }
  }
</script>

<style scoped>
  .section {
    padding: 0.8rem 1.5rem;
  }
  .flex-column {
    display: flex;
  }
  .topic-card {
    border-radius: 10px 135px 10px 10px;
    opacity: .7;
    transition: opacity .5s ease-out;
    -moz-transition: opacity .5s ease-out;
    -webkit-transition: opacity .5s ease-out;
    -o-transition: opacity .5s ease-out;
  }
  .topic-card:hover {
    opacity: 1;
  }
  @media (max-width: 1460px) { .topic-card { border-radius: 10px 115px 10px 10px; } }
  @media (max-width: 1240px) { .topic-card { border-radius: 10px 100px 10px 10px; } }
  @media (max-width: 1088px) { .topic-card { border-radius: 10px 115px 10px 10px; } }
  @media (max-width: 1000px) { .topic-card { border-radius: 10px 100px 10px 10px; } }
  @media (max-width: 860px) { .topic-card { border-radius: 10px 90px 10px 10px; } }
  @media (max-width: 768px) { .topic-card { border-radius: 10px 155px 10px 10px; } }
  @media (max-width: 640px) { .topic-card { border-radius: 10px 125px 10px 10px; } }
  @media (max-width: 540px) { .topic-card { border-radius: 10px 105px 10px 10px; } }
  @media (max-width: 480px) { .topic-card { border-radius: 10px 95px 10px 10px; } }
  @media (max-width: 420px) { .topic-card { border-radius: 10px 80px 10px 10px; } }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ListBestPracticeTopics.vue